import axios from "axios";
import React, { useMemo, useState, useEffect } from "react";

import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import theme from "../styles/theme";
import Status from "../types/enum/Status";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon, { ClickableIcon } from "./Icon";
import Input from "./Input";
import Modal from "./Modal";
import { Col, Row } from "./StyledGridSystem";
import { RightAlign } from "./UtilsComponents";

type UploadDetailModalProps = {
  isOpen: boolean;
  setOpen: (x: boolean) => void;
  uploadDetail: any;
  //   currentCourse: { [key: string]: any };
  //   showSections?: boolean;
  //   // handleDeleteCourse: (regId: string) => void
  //   onDeleteComplete?: () => void;
  //   onDeleteError?: (err: any) => void;
};

const UploadDetailModal = ({
  isOpen,
  setOpen,
  uploadDetail,
}: //   currentCourse,
//   // handleDeleteCourse,
//   onDeleteError,
//   onDeleteComplete,
UploadDetailModalProps): JSX.Element => {
  const screenClass = useScreenClass();
  const [deletePasswordInput, setDeletePasswordInput] = useState<string>("");
  const [isOpenComplete, setOpenComplete] = useState<boolean>(false);
  const [isOpenError, setOpenError] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const onComplete = () => {
    setOpenComplete(false);
    setOpen(false);
    // onDeleteComplete?.();
  };

  const onError = () => {
    setOpen(false);
    setOpenError(false);
    // onDeleteError?.(error);
  };

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpenComplete}
      onClose={onComplete}
      customStyle={{
        content: {
          textAlign: "center",
        //   minWidth: "500px !important",
          maxWidth: "550px",
          width: "500px !important",
        },
      }}
    >
      <h3>Course Alias Upload</h3>
      {uploadDetail?.map((detail: string) => (
        <p
          style={{
            fontWeight: detail?.includes("Success") ?'bold': "normal",
            textAlign: "left",
            color: detail?.includes("Success") ? "#009300" : "#7f3000",
          }}
        >
          {detail}
        </p>
      ))}
      <Button status={Status.primary} onClick={onComplete}>
        Done
      </Button>
    </Modal>
  );
};

export default UploadDetailModal;
